import { render, staticRenderFns } from "./DomesticApplicants.vue?vue&type=template&id=f683e4f0&"
import script from "./DomesticApplicants.vue?vue&type=script&lang=js&"
export * from "./DomesticApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports